<template>
  <div>
    <div class="form-container">
      <div class="form-title">评级办法管理</div>
      <eSteps :step-list="showStepList" :is-active="isActive"></eSteps>
    </div>
    <!--基础信息-->
    <StepOne
      v-if="step === 1"
      :supplier-type="supplierType"
      :evaluation-id="evaluationId"
      @getStep="getStep"
    ></StepOne>
    <!--基本资质审查-->
    <StepTwo
      v-if="step === 2"
      :supplier-type="supplierType"
      :evaluation-id="evaluationId"
      @getStep="getStep"
    ></StepTwo>
    <!--生产审查-->
    <StepThree
      v-if="step === 3"
      :supplier-type="supplierType"
      :evaluation-id="evaluationId"
      @getStep="getStep"
    ></StepThree>
    <!--  -->
    <!-- <ESteps :active></ESteps> -->
    <StepFour
      v-if="step === 4"
      :supplier-type="supplierType"
      :evaluation-id="evaluationId"
      @getStep="getStep"
    ></StepFour>
    <StepFive
      v-if="step === 5"
      :supplier-type="supplierType"
      :evaluation-id="evaluationId"
      @getStep="getStep"
    ></StepFive>
  </div>
</template>

<script>
import StepOne from './components/stepOne';
import StepTwo from './components/stepTwo';
import StepThree from './components/stepThree';
import StepFour from './components/stepFour';
import StepFive from './components/stepFive';
import eSteps from '../../../components/common/e-steps.vue';
/* import ESteps from '@/modules/projectA/components/common/e-steps.vue'; */
export default {
  components: {
    StepOne,
    StepTwo,
    StepThree,
    StepFour,
    StepFive /* ESteps */,
    eSteps,
  },
  data() {
    return {
      isActive: 0,
      showStepList: [],
      // 生产商
      scsStepList: [
        { id: 1, title: '基础信息' },
        { id: 2, title: '表1', description: '基本资质审查' },
        { id: 3, title: '表2', description: '生产能力保障审查' },
        {
          id: 4,
          title: '表3&表4&表5',
          description: '产品单元划分&检测内容和依据',
        },
        { id: 5, title: '业务咨询人' },
      ],
      // 流通商
      ltsStepList: [
        { id: 1, title: '基础信息' },
        { id: 2, title: '表1', description: '基本资质审查' },
        { id: 3, title: '表2', description: '服务保障能力审查' },
        { id: 5, title: '评价范围', description: '业务咨询人' },
      ],
      step: '',
      supplierType: '',
      evaluationId: '',
    };
  },
  computed: {},
  created() {
    const { step, supplierType, evaluationId } = this.$route.query;
    this.evaluationId = Number(evaluationId);
    this.supplierType = supplierType || '103';
    this.step = Number(step) || 1;
    this.isActive = Number(step) - 1;
    if (this.supplierType === '101') {
      this.showStepList = this.scsStepList;
    } else {
      this.showStepList = this.ltsStepList;
    }
  },
  methods: {
    getStep(step) {
      console.log(step);
      this.isActive = Number(step) - 1;
      this.step = step;
    },
  },
};
</script>
<style lang="scss" scoped></style>
